/**
 * ======================================================
 * CATALOGUE DES INTERETS
 * ======================================================
 *
 * Source de verite partagee entre :
 * - centres d'interet utilisateur
 * - categories d'evenements
 * - recommandations futures
 */

export const INTEREST_CATALOG = [
  {
    id: "sorties",
    label: "Sorties",
    emoji: "\uD83C\uDF89",
    group: "Social",
    section: "share",
    description: "Afterworks, festivals et plans improvises.",
  },
  {
    id: "food",
    label: "Food",
    emoji: "\uD83C\uDF5D",
    group: "Social",
    section: "share",
    description: "Brunch, restos, cuisine et bonnes adresses.",
  },
  {
    id: "musique",
    label: "Musique",
    emoji: "\uD83C\uDFB5",
    group: "Social",
    section: "share",
    description: "Concerts, live et DJ sets.",
  },
  {
    id: "danse",
    label: "Danse",
    emoji: "\uD83D\uDC83",
    group: "Social",
    section: "share",
    description: "Soirees, pratiques et social dance.",
  },
  {
    id: "sport",
    label: "Sport",
    emoji: "\uD83C\uDFC3",
    group: "Mouvement",
    section: "move",
    description: "Running, velo, boxe, surf et effort.",
  },
  {
    id: "bienetre",
    label: "Bien-etre",
    emoji: "\uD83E\uDDD8",
    group: "Mouvement",
    section: "move",
    description: "Yoga, respiration, energie douce et equilibre.",
  },
  {
    id: "nature",
    label: "Nature",
    emoji: "\uD83C\uDF3F",
    group: "Mouvement",
    section: "move",
    description: "Rando, outdoor, grand air et escapades vertes.",
  },
  {
    id: "voyage",
    label: "Voyage",
    emoji: "\u2708\uFE0F",
    group: "Mouvement",
    section: "move",
    description: "Road trips, city breaks et decouvertes.",
  },
  {
    id: "culture",
    label: "Culture",
    emoji: "\uD83C\uDFA8",
    group: "Ouverture",
    section: "explore",
    description: "Cine, photo, expos, lecture et curiosite.",
  },
  {
    id: "gaming",
    label: "Gaming",
    emoji: "\uD83C\uDFAE",
    group: "Ouverture",
    section: "explore",
    description: "Jeux video, coop et sessions a partager.",
  },
  {
    id: "famille",
    label: "Famille",
    emoji: "\uD83D\uDC6A",
    group: "Ouverture",
    section: "explore",
    description: "Formats kids friendly et moments a plusieurs.",
  },
  {
    id: "pro",
    label: "Pro",
    emoji: "\uD83D\uDCBC",
    group: "Ouverture",
    section: "explore",
    description: "Networking, business et ateliers utiles.",
  },
];
